/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_Combined_Continuity_DialogueInputs */



/**
* | output |
* | --- |
* | "COMBINED CONTINUITY & DIALOGUE" |
*
* @param {Ccsl_Export_Header_Combined_Continuity_DialogueInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_combined_continuity_dialogue = /** @type {((inputs?: Ccsl_Export_Header_Combined_Continuity_DialogueInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_Combined_Continuity_DialogueInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("CONTINUITE ET DIALOGUE COMBINES")
	if (locale === "de") return /** @type {LocalizedString} */ ("KOMBINIERTE KONTINUITÄT & DIALOG")
	if (locale === "it") return /** @type {LocalizedString} */ ("CONTINUITÀ E DIALOGO COMBINATI")
	if (locale === "ru") return /** @type {LocalizedString} */ ("СОВМЕСТНАЯ НЕПРЕРЫВНОСТЬ И ДИАЛОГ")
	if (locale === "es") return /** @type {LocalizedString} */ ("CONTINUIDAD Y DIÁLOGO COMBINADOS")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("连续性与对话相结合")
	if (locale === "ja") return /** @type {LocalizedString} */ ("連続性と対話の融合")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संयुक्त निरंतरता और संवाद")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("CONTINUIDADE E DIÁLOGO COMBINADOS")
	return /** @type {LocalizedString} */ ("COMBINED CONTINUITY & DIALOGUE")
});